import React from 'react';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section id="hero" className="relative w-full bg-[#0A0A0A] flex flex-col items-center pt-32 pb-24 overflow-hidden" data-id="element-53">
      <div className="w-full max-w-5xl mx-auto px-6 mb-16" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} className="w-full aspect-[16/9] md:aspect-[21/9] overflow-hidden" data-id="element-55">
          <img src="https://cdn.magicpatterns.com/uploads/vVqJ93tbrTwqzLah1aHMdu/banner_5.png" alt="FLA Banner" className="w-full h-full object-cover object-center opacity-90" data-id="element-56" />
        </motion.div>
      </div>

      <div className="flex flex-col items-center text-center px-6 max-w-3xl mx-auto mt-8" data-id="element-57">
        <motion.h3 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.7
      }} className="font-serif text-3xl md:text-5xl text-offwhite font-light tracking-wide leading-tight mb-12 uppercase" data-id="element-58">
          Tu color, diseñado a mano.
          <br data-id="element-59" />
          Tu estilo, pensado para vos.
        </motion.h3>

        <motion.button initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.9
      }} className="border border-gold text-gold px-10 py-4 hover:bg-gold hover:text-[#0A0A0A] transition-colors font-sans text-xs tracking-[0.2em] uppercase" data-id="element-60">
          Reservar tu lugar
        </motion.button>
      </div>
    </section>;
};